//import { GoogleMap } from 'ionic-native';
//import { CommonHeaderComponent } from '../components/common-header/common-header';

import { NgModule, ErrorHandler, Renderer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicApp, IonicModule, IonicErrorHandler, NavController, Platform } from 'ionic-angular';
import { MyApp } from './app.component';
import { HttpModule, Http } from '@angular/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { LokiDbProvider } from '../providers/loki-db/loki-db';
import { FirebaseServiceProvider } from '../providers/firebase-service/firebase-service';
import { NetworkConnectionProvider } from '../providers/network-connection/network-connection';
import { ActionsProvider } from '../providers/actions/actions';
import { FIREBASE_CONFIG } from './app.firebase.config';
import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { Push } from '@ionic-native/push';
import { Network } from '@ionic-native/network';
import { Keyboard } from '@ionic-native/keyboard';
import { CallNumber } from '@ionic-native/call-number';
import { Contacts } from '@ionic-native/contacts';
import { SocialSharing } from '@ionic-native/social-sharing';
import { TabsPage } from '../pages/tabs/tabs';
import { CommonHeaderComponentModule } from '../components/common-header/common-header.module';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { AppVersion } from '@ionic-native/app-version';
import { GoogleAnalytics } from '@ionic-native/google-analytics';


//import { GoogleMaps } from '@ionic-native/google-maps';
import { ScreenOrientation } from '@ionic-native/screen-orientation';



export function createTranslateLoader(http: Http, platform: Platform) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
      MyApp
  ],
  imports: [
    BrowserModule,
    HttpModule,
    CommonHeaderComponentModule,
    IonicModule.forRoot(MyApp, { mode: 'md' }),
    AngularFireModule.initializeApp(FIREBASE_CONFIG),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    TranslateModule.forRoot({
    loader: {
      provide: TranslateLoader,
      useFactory: (createTranslateLoader),
      deps: [Http]
    }
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
      MyApp
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    LokiDbProvider,
    Push,
    FirebaseServiceProvider,
    NetworkConnectionProvider,
    Network,
    Keyboard,
    CallNumber,
    Contacts,
    SocialSharing,
    ActionsProvider,
    ScreenOrientation,
    InAppBrowser,
    AppVersion,
    GoogleAnalytics
    //GoogleMaps
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts